import {
  SHOW_MOBILE_NAV,
  HIDE_MOBILE_NAV,
  SHOW_CREATE_INBOX,
  HIDE_CREATE_INBOX,
  TOGGLE_CREATE_MESSAGE,
  TOGGLE_NEW_WORKFLOW_MODAL,
  TOGGLE_DIALER,
  SHOW_10DLC_BANNER,
  HIDE_10DLC_BANNER,
} from './types';

const initialState = {
  showMobileNav: false,
  showCreateInbox: false,
  showCreateMessage: false,
  showNewWorkflowModal: false,
  showDialer: false,
  show10DLCBanner: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_MOBILE_NAV:
      return {
        ...state,
        showMobileNav: true,
      };
    case HIDE_MOBILE_NAV:
      return {
        ...state,
        showMobileNav: false,
      };
    case SHOW_CREATE_INBOX:
      return {
        ...state,
        showCreateInbox: true,
      };
    case HIDE_CREATE_INBOX: {
      return {
        ...state,
        showCreateInbox: false,
      };
    }
    case TOGGLE_CREATE_MESSAGE: {
      return {
        ...state,
        showCreateMessage: payload,
      };
    }
    case TOGGLE_NEW_WORKFLOW_MODAL: {
      return {
        ...state,
        showNewWorkflowModal: payload,
      };
    }
    case TOGGLE_DIALER: {
      return {
        ...state,
        showDialer: payload.show ? payload.params ?? {} : false,
      };
    }
    case SHOW_10DLC_BANNER:
      return {
        ...state,
        show10DLCBanner: payload,
      };
    case HIDE_10DLC_BANNER:
      return {
        ...state,
        show10DLCBanner: false,
      };
    default:
      return state;
  }
};
